import React from 'react';
import HomeFunctional from './componenet/home-functional';
import './home-main.scss';

const HomeMain = () => {
	return <HomeFunctional />;
};

export default HomeMain;
